import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import SafetyGuidePage from "@/pages/article/safety-guide/page";
import ShoesGuidePage from "@/pages/article/shoes-guide/page";
import HoodiesGuidePage from "@/pages/article/hoodies-guide/page";
import BuyingTipsPage from "@/pages/article/buying-tips/page";
import ProductComparisonPage from "@/pages/article/product-comparison/page";
import BeginnerTutorialPage from "@/pages/article/beginner-tutorial/page";
import QCGuidePage from "@/pages/article/qc-guide/page";
import Trending2026Page from "@/pages/article/trending-2026/page";
import ExpertStrategiesPage from "@/pages/article/expert-strategies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-shoes-guide",
    element: <ShoesGuidePage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-hoodies-guide",
    element: <HoodiesGuidePage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-buying-tips",
    element: <BuyingTipsPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-product-comparison",
    element: <ProductComparisonPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-beginner-tutorial",
    element: <BeginnerTutorialPage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-qc-guide",
    element: <QCGuidePage />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-trending-2026",
    element: <Trending2026Page />,
  },
  {
    path: "/article/vigorbuy-spreadsheet-expert-strategies",
    element: <ExpertStrategiesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;